<template>
  <div>
    <h3>
      <el-page-header @back="$router.push('/plant/scheme')" :content="title" />
    </h3>
    <el-form
      id="scheme-form"
      ref="form"
      :model="form"
      size="small"
      label-position="top"
      :rules="rules"
    >
      <el-collapse v-model="activeCollapse" style="border-bottom: 1px solid">
        <el-collapse-item name="1">
          <div slot="title">
            <i class="el-icon-document"></i>
            第一部分：基本信息
          </div>
          <div style="padding: 10px">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="方案名称" prop="name">
                      <el-input
                        v-model="form.name"
                        placeholder="为方案起个名字，便于识别和交流"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="16">
                    <el-form-item label="适用品种" prop="varietyId">
                      <el-select
                        v-model="form.varietyId"
                        placeholder="选择适用的品种"
                      >
                        <el-option
                          v-for="(v, index) in varietyOptions"
                          :key="index"
                          :label="v.name"
                          :value="v.id"
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="总阶段数" prop="phaseCount">
                      <el-input readonly v-model="form.phaseCount"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="18">
                <el-form-item label="方案介绍" prop="memo">
                  <el-input
                    v-model="form.memo"
                    type="textarea"
                    :rows="6"
                    placeholder="输入本方案的说明介绍，如方案的特色、优势、整体注意要点等"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item>
              <el-button type="primary" @click="handleAdd(form.phaseCount)">
                添加阶段
              </el-button>
              <el-button type="success" @click="save('form')">
                填好了，保存
              </el-button>
            </el-form-item>
          </div>
        </el-collapse-item>
        <!-- 以下是阶段列表 -->
        <scheme-phase v-for="(p, i) in form.phases" :key="i" :phase-data="p">
          <span slot="reorder">
            <i
              class="el-icon-top"
              @click.stop="up(i)"
              v-show="i !== 0"
              style="cursor: pointer"
            />
            <i
              class="el-icon-bottom"
              @click.stop="down(i)"
              v-show="i !== form.phases.length - 1"
              style="cursor: pointer"
            />
          </span>
          <i
            slot="remove"
            class="el-icon-close"
            @click.stop="deletePhase(p.index)"
            style="cursor: pointer; color: #f56c6c"
          />
        </scheme-phase>
      </el-collapse>
    </el-form>
  </div>
</template>
<script>
import defaultValue from './scheme-default.js'
import { getAllVarieties } from '@/api/variety2.js'
import {
  getProgrammeDataById,
  addProgrammeData,
  updateProgrammeData,
} from '@/api/programme.js'
import SchemePhase from './SchemeDetailPhase.vue'
export default {
  name: 'SchemeDetail',
  components: { SchemePhase },
  data() {
    return {
      activeCollapse: ['1'],
      form: undefined,
      varietyOptions: [],
      i: 0,
      enterpriseId: 1,
      rules: {
        name: [
          { required: true, message: '方案名称不能为空', trigger: 'blur' },
        ],
        varietyId: [
          { required: true, message: '品种不能为空', trigger: 'blur' },
        ],
      },
    }
  },
  computed: {
    id() {
      return parseInt(this.$route.params.id)
    },
    creating() {
      return isNaN(this.id)
    },
    title() {
      return (this.creating ? '新建' : '编辑') + '种植模型'
    },
  },
  watch: {
    'form.phases': {
      handler: function (form) {
        this.form.phases.forEach((item, index) => {
          item.index = index + 1
        })
      },
      deep: true,
    },
  },
  created() {
    // 初始化品种选项
    getAllVarieties().then((resp) => {
      this.varietyOptions = resp.data.list
    })
    // 如果是编辑模式，先读取数据
    const { creating, id } = this
    if (creating) {
      this.form = JSON.parse(JSON.stringify(defaultValue))
    } else {
      getProgrammeDataById(id).then((resp) => {
        let arr = JSON.parse(resp.data.phases)
        this.editForm = arr
        this.form = resp.data
        console.log(this.form)
        this.form.phases = arr
      })
    }
  },
  mounted() {
    if (!this.$route.params.id) {
      let arr = this.form.phases.filter((item) => {
        return item.badge != ''
      })
      this.form.phases = arr
      this.form.phaseCount = 2
    }
  },
  methods: {
    // 添加阶段
    handleAdd(index) {
      let phases = {
        name: null,
        index: index + 1,
        badge: '', //收获期阶段特殊标识
        suggest: [],
        dutation: 1,
        environs: {
          airt: [15, 25], //空气温度
          airh: [30, 50], //空气湿度
          illu: [3, 6], //光照强度
          co2: [200, 600], //二氧化碳
          soilt: [18, 28], //土壤温度度
          soilh: [30, 50], //土壤湿度
          adh: [500, 800], //积温
          par: [2000, 5000],
        },
        switchValue: false, //参数开关
      }
      this.form.phases.push(phases)
      this.form.phaseCount = this.form.phases.length
    },
    // 删除阶段
    deletePhase(index) {
      let arr = this.form.phases
      //  根据下标删除卡片
      arr.splice(
        arr.findIndex((e) => e.index === index),
        1
      )
      this.form.phaseCount = this.form.phases.length
    },
    // 阶段排序
    up(index) {
      const temp = this.form.phases[index]
      this.$set(this.form.phases, index, this.form.phases[index - 1])
      this.$set(this.form.phases, index - 1, temp)
    },
    down(index) {
      const temp = this.form.phases[index]
      this.$set(this.form.phases, index, this.form.phases[index + 1])
      this.$set(this.form.phases, index + 1, temp)
    },
    // 提交表单
    save(form) {
      let days = 0
      this.form.phases.forEach((item) => {
        days = days + Number(item.dutation)
        if (item.badge === 'plant') {
          // 表单添加字段，表示栽种默认阶段距离整个阶段起始的天数
          this.form.plantDay = days - Number(item.dutation) + 1
        }
        if (item.badge === 'harvest') {
          // 表单添加字段，表示栽种默认阶段距离整个阶段起始的天数
          this.form.harvestDay = days - Number(item.dutation) + 1
        }
      })
      this.form.varietyName = this.varietyOptions.find(
        (item) => item.id === this.form.varietyId
      ).name
      if (this.$route.query.id !== undefined) {
        this.form.phases = this.editForm
      }
      let sureFlag = true
      if (this.form.phases) {
        this.form.phases.forEach((item) => {
          if (item.dutation == '' || !item.dutation) {
            this.$message.error('阶段天数都不能为空')
            sureFlag = false
          }
          //开关值为true则将environs字段赋空
          if (item.switchValue) {
            item.environs = []
          }
        })
      }
      if (!sureFlag) {
        return
      }
      this.$refs[form].validate((valid) => {
        if (valid) {
          if (!this.form.id) {
            this.form.enterpriseId = this.enterpriseId
            this.form.phaseCount = this.form.phases.length
            let d = 0
            this.form.phases.forEach((item) => {
              d += parseInt(item.dutation)
            })
            this.form.duration = d
            addProgrammeData(this.form).then((data) => {
              this.$emit('ProgrammeData')
              this.$router.push('/plant/scheme/list')
            })
          } else {
            let d = 0
            this.form.phases.forEach((item) => {
              d += parseInt(item.dutation)
            })
            this.form.duration = d
            this.form.enterpriseId = this.enterpriseId
            updateProgrammeData(this.form).then((data) => {
              console.log(this.form)
              this.$emit('ProgrammeData')
              this.form.id = parseInt(this.$route.params.id)
              this.$router.push('/plant/scheme/list')
            })
          }
        }
      })
    },
  },
}
</script>
<style scoped>
</style>
<style>
#scheme-form .el-collapse-item__header {
  font-size: 16px;
  border-top: solid 1px #ccc;
  background-color: #f9f9f9;
  width: 100%;
  text-indent: 4px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/plant/programme/SchemeDetail.vue